<template>
  <mf-button v-if="url" label="Baixar imagem" text icon="download" color="marca-0-l40" @click="downloadImage" />
</template>

<script>
export default {
  name: 'DownloadImageButton',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  methods: {
    downloadImage() {
      const link = document.createElement('a')
      link.href = this.url
      link.setAttribute('target', '_blank')
      link.click()
    },
  },
}
</script>
